/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { NewsContext, useNewsContext } from './news-context'
import type * as Fetcher from './news-fetcher'
import { newsFetch } from './news-fetcher'
import type * as Schemas from './news-schemas'

export type NewsRequestListPathParams = {
  templateBasePath: string
}

export type NewsRequestListQueryParams = {
  /**
   * Position of the first element to return
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  pagingOffset?: number
  /**
   * Maximum number of rows to return
   *
   * @format int32
   * @default 20
   * @minimum 1
   */
  pagingLimit?: number
}

export type NewsRequestListHeaders = {
  ['X-Locale']?: string
}

export type NewsRequestListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type NewsRequestListVariables = {
  headers?: NewsRequestListHeaders
  pathParams: NewsRequestListPathParams
  queryParams?: NewsRequestListQueryParams
} & NewsContext['fetcherOptions']

/**
 * Returns the list of the News
 */
export const fetchNewsRequestList = (variables: NewsRequestListVariables, signal?: AbortSignal) =>
  newsFetch<
    Schemas.NewsPaginated,
    NewsRequestListError,
    undefined,
    NewsRequestListHeaders,
    NewsRequestListQueryParams,
    NewsRequestListPathParams
  >({
    url: '/{templateBasePath}/pages/news',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the list of the News
 */
export const useNewsRequestList = <TData = Schemas.NewsPaginated>(
  variables: NewsRequestListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.NewsPaginated, NewsRequestListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNewsContext(options)
  return reactQuery.useQuery<Schemas.NewsPaginated, NewsRequestListError, TData>({
    queryKey: queryKeyFn({
      path: '/{templateBasePath}/pages/news',
      operationId: 'newsRequestList',
      variables,
    }),
    queryFn: ({ signal }) => fetchNewsRequestList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type NewsRequestGetPathParams = {
  id: string
}

export type NewsRequestGetHeaders = {
  ['X-Locale']?: string
}

export type NewsRequestGetError = Fetcher.ErrorWrapper<{
  status: 404
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type NewsRequestGetVariables = {
  headers?: NewsRequestGetHeaders
  pathParams: NewsRequestGetPathParams
} & NewsContext['fetcherOptions']

/**
 * Returns the details of the News
 */
export const fetchNewsRequestGet = (variables: NewsRequestGetVariables, signal?: AbortSignal) =>
  newsFetch<Schemas.News, NewsRequestGetError, undefined, NewsRequestGetHeaders, {}, NewsRequestGetPathParams>({
    url: '/news/{id}',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the details of the News
 */
export const useNewsRequestGet = <TData = Schemas.News>(
  variables: NewsRequestGetVariables,
  options?: Omit<reactQuery.UseQueryOptions<Schemas.News, NewsRequestGetError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNewsContext(options)
  return reactQuery.useQuery<Schemas.News, NewsRequestGetError, TData>({
    queryKey: queryKeyFn({
      path: '/news/{id}',
      operationId: 'newsRequestGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchNewsRequestGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type QueryOperation =
  | {
      path: '/{templateBasePath}/pages/news'
      operationId: 'newsRequestList'
      variables: NewsRequestListVariables
    }
  | {
      path: '/news/{id}'
      operationId: 'newsRequestGet'
      variables: NewsRequestGetVariables
    }
